var _defs, _rect, _circle, _path, _rect2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesignToolShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".design-tool-shape_svg__design-tool-shape_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "design-tool-shape_svg__design-tool-shape_svg__a",
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 1,
    ry: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "design-tool-shape_svg__design-tool-shape_svg__a",
    cx: 7.883,
    cy: 10.867,
    r: 4.117
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "design-tool-shape_svg__design-tool-shape_svg__a",
    d: "M11.984 10.5h2.052A.965.965 0 0015 9.536V4.714a.965.965 0 00-.964-.964H9.214a.965.965 0 00-.964.964v2.052M3.75 18.75h9m1.696-4.505l2.817 2.348"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "design-tool-shape_svg__design-tool-shape_svg__a",
    x: 17.25,
    y: 15.75,
    width: 3,
    height: 4.5,
    rx: 1,
    ry: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "design-tool-shape_svg__design-tool-shape_svg__a",
    d: "M18 4.5h2.25M18 7.5h2.25"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB4PSIwLjc1IiB5PSIwLjc1IiB3aWR0aD0iMjIuNSIgaGVpZ2h0PSIyMi41IiByeD0iMSIgcnk9IjEiLz48Y2lyY2xlIGNsYXNzPSJhIiBjeD0iNy44ODMiIGN5PSIxMC44NjciIHI9IjQuMTE3Ii8+PHBhdGggY2xhc3M9ImEiIGQ9Ik0xMS45ODQsMTAuNWgyLjA1MkEuOTY1Ljk2NSwwLDAsMCwxNSw5LjUzNlY0LjcxNGEuOTY1Ljk2NSwwLDAsMC0uOTY0LS45NjRIOS4yMTRhLjk2NS45NjUsMCwwLDAtLjk2NC45NjRWNi43NjYiLz48bGluZSBjbGFzcz0iYSIgeDE9IjMuNzUiIHkxPSIxOC43NSIgeDI9IjEyLjc1IiB5Mj0iMTguNzUiLz48bGluZSBjbGFzcz0iYSIgeDE9IjE0LjQ0NiIgeTE9IjE0LjI0NSIgeDI9IjE3LjI2MyIgeTI9IjE2LjU5MyIvPjxyZWN0IGNsYXNzPSJhIiB4PSIxNy4yNSIgeT0iMTUuNzUiIHdpZHRoPSIzIiBoZWlnaHQ9IjQuNSIgcng9IjEiIHJ5PSIxIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSIxOCIgeTE9IjQuNSIgeDI9IjIwLjI1IiB5Mj0iNC41Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSIxOCIgeTE9IjcuNSIgeDI9IjIwLjI1IiB5Mj0iNy41Ii8+PC9zdmc+Cg==";
export { SvgDesignToolShape as ReactComponent };